import React from 'react'
import { BeWizrMeeting } from '~/models'
import { memo } from '~/ui/component'
import BeWizrMeetingTile from '../../bewizr-meetings/BeWizrMeetingTile'
import { register } from './registry'
import { useTranslation } from 'react-i18next'

export interface Props {
  item: BeWizrMeeting
}

const BeWizrMeetingLibraryItem = memo('BeWizrMeetingLibraryItem', (props: Props) => {

  const {item} = props

  const occurrence = item.occurrences.length === 1 ? item.occurrences[0] : null

  const [t] = useTranslation('bewizr-library')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrMeetingTile
        label={t('item-types.meeting')}
        meetingID={item.id}
        occurrenceID={occurrence?.id}
        title={item.title}
        image={item.links.image}
        capacity={occurrence?.capacity}
        isEnrolled={occurrence?.isEnrolled}
        isOnWaitingList={occurrence?.isOnWaitingList}
        placesLeft={occurrence?.placesLeft}
        startDate={occurrence?.startDate}
        endDate={occurrence?.endDate}
        mayEnroll={occurrence?.mayEnroll}
        description={item.shortDescription}
        horizontal
      />
    )
  }

  return render()

})

register('meeting', BeWizrMeetingLibraryItem)